var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoiseSuppressionOn = function SvgNoiseSuppressionOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5a.833.833 0 0 0-.833.833v13.334a.833.833 0 0 0 1.666 0V3.333A.833.833 0 0 0 10 2.5ZM6.667 5a.833.833 0 0 0-.834.833v8.334a.833.833 0 0 0 1.667 0V5.833A.833.833 0 0 0 6.667 5ZM2.5 8.333a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0V8.333Zm10 0a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0V8.333Zm3.333-2.5a.833.833 0 0 1 1.667 0v8.334a.833.833 0 0 1-1.667 0V5.833Z"
  })));
};

export default SvgNoiseSuppressionOn;